// src/Maintenance.jsx
import React from "react";

const MaintenanceLayout = () => (
  <div style={{ textAlign: "center", marginTop: "20vh" }}>
    <h1>🚧 System Down Alert 🚧</h1>
    <p>The Pricing App is currently unavailable due to a system-wide outage in Snowflake. We are actively monitoring the situation and will restore access as soon as Snowflake resolves the issue.</p>
  </div>
);

export default MaintenanceLayout;
